// extracted by mini-css-extract-plugin
export var draftAttachmentContainer = "_ic-0";
export var fileCarousel = "_ic-2";
export var removeFileButton = "_ic-1";